import { useEffect, useRef } from '@wordpress/element';

export const Block = ({}) => {
    const isClearing = useRef(false);

    const fetchAndRenderForm = () => {
        if (isClearing.current) return; 

        fetch(ka_up_cart_block_data.admin_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'ka_up_get_cart_form_html',
                nonce: ka_up_cart_block_data.nonce,
            })
        })
        .then(res => res.json())
        .then(data => {
            // if (data.success) {
            //     renderForm(data.data.concat_html, data.data.cart_position);
            // } else {
            //     jQuery('.ka-up-inner-div').empty();
            //     clearUploadedFiles();
            // }
            if (data) {
                jQuery('.ka-up-inner-div').empty();
                clearUploadedFiles();
            }             
        });
    };

    const clearUploadedFiles = () => {
        isClearing.current = true; 

        fetch(ka_up_cart_block_data.admin_url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: new URLSearchParams({
                action: 'ka_up_clear_cart_uploaded_files',
                nonce: ka_up_cart_block_data.nonce,
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log('clearUploadedFiles response:', data);
            if (data.success) {
                wp.data.dispatch('wc/store/cart').invalidateResolutionForStore();
            }
        })
        .catch(err => {
            console.error('clearUploadedFiles error:', err);
        })
        .finally(() => {

            setTimeout(() => {
                isClearing.current = false;
            }, 2000);
        });
    };

    const renderForm = (html, cartPosition) => {
        switch (cartPosition) {
            case 'before_cart_total_heading':
                jQuery('.ka-up-inner-div').html(html);
                jQuery('.ka-up-inner-div').insertBefore('.wp-block-woocommerce-cart-order-summary-heading-block');
                jQuery('.ka-up-inner-div').show();
                break;
            case 'after_cart_total_heading':
                jQuery('.ka-up-inner-div').html(html);
                jQuery('.ka-up-inner-div').insertAfter('.wp-block-woocommerce-cart-order-summary-heading-block');
                jQuery('.ka-up-inner-div').show();
                break;
            case 'shortcode':
                jQuery('.ka-up-inner-div').empty();
                break;
            default:
                jQuery('.ka-up-inner-div').html(html);
        }

        jQuery('.wp-block-woocommerce-proceed-to-checkout-block').off('click.ka_up').on('click.ka_up', function() {
            if (jQuery('#cart_pag_discalimer_id').length > 0) {
                if (jQuery('#cart_pag_discalimer_id').is(':checked')) {
                    jQuery('#enable_checkbox_message').hide();
                } else {
                    jQuery('.enable_checkbox_message').show();
                    return false;
                }
            }
        });
    };

    useEffect(() => {
        setTimeout(() => {
            if (typeof ka_up_cart_block_data !== 'undefined') {
                renderForm(ka_up_cart_block_data.concat_html, ka_up_cart_block_data.cart_position);
            }
        }, 1000);

        let lastCartCount = jQuery('.wc-block-cart-items__row').length;

        const cartObserver = new MutationObserver(() => {
            if (isClearing.current) return; 

            const currentCount = jQuery('.wc-block-cart-items__row').length;
            if (currentCount !== lastCartCount) {
                lastCartCount = currentCount;
                if (typeof ka_up_cart_block_data !== 'undefined') {
                    fetchAndRenderForm();
                }
            }
        });

        const cartItemsContainer = document.querySelector('.wp-block-woocommerce-cart');
        if (cartItemsContainer) {
            cartObserver.observe(cartItemsContainer, { childList: true, subtree: true });
        }

        return () => {
            cartObserver.disconnect();
        };
    }, []);

    return (
        <div className="ka-up-inner-div" id="ka_up_id_cart_page_form_data"></div>
    );
};